import axios from './axios';
import { store } from '../index';
import { Cookies } from 'react-cookie';
import { getGlobalShowError, useError } from '../helpers/ErrorContext';
import { humanErrorText } from '../helpers/errorText';
import alert from '../helpers/alert';
const cookies = new Cookies();

const defaultHeaders = async (accessToken) => {
  return {
    'Content-Type': 'application/json',
    // Authorization: `Bearer ${store?.getState()?.user?.token}`,
    Authorization: `Bearer ${cookies.get('access_token')}`,
  };
};

// Ошибки этих запросов обрабатываются на месте и не фатальны — глобальную
// модалку с ошибкой по ним не показываем.
// Сверяем по концу пути, а не по вхождению: иначе '/createComplectation'
// глушил бы и '/createComplectationOptions'.
const IGNORE_URLS = [
  '/getDcRequisites',
  // Проверка БМГ: если сервис не ответил, вызывающий экран сам показывает
  // понятный текст (BMG_UNAVAILABLE_MESSAGE), модалка со стеком не нужна.
  '/bmg/phoneBelongsIinValidate',
  // Справочники, заводимые прямо в селекте (б/у по договору поручения):
  // «марка уже существует» и т.п. показываем тостом рядом с полем.
  '/createMark',
  '/createModel',
  '/createComplectation',
  '/ensureContainer',
  // Справочники марок и моделей: причину отказа («у марки есть модели»,
  // «к модели привязаны автомобили») показываем тостом на самой странице.
  '/deleteMark',
  '/deleteModel',
  // Обновление таблицы отчёта и загрузка выгрузок сторов: карточка на странице «Отчёты» сама показывает причину
  // рядом с кнопкой, а статус опрашивается каждые несколько секунд — модалка на каждый сбой была бы лишней.
  '/crm/reports/app-refresh',
  '/crm/reports/app-installs/import',
];

export default class api {
  static onError(error) {
    console.log('[API ERROR]:', error);

    const showError = getGlobalShowError();

    if (error?.response?.data?.error === 'ОТП не подписан') {
      return Promise.reject(error);
    }

    let message =
      error?.response?.data?.errorMessage ||
      error?.response?.data?.message ||
      error?.message;

    if (!message && error?.response?.data) {
      if (typeof error.response.data === 'string') {
        message = error.response.data;
      } else {
        message = JSON.stringify(error.response.data);
      }
    }

    if (!message) {
      message = 'Неизвестная ошибка';
    }

    const details = error?.response?.data || error?.toJSON?.() || error;

    if (showError && !IGNORE_URLS.some((url) => error?.config?.url?.endsWith(url))) {
      // Если бэкенд объяснил причину по-человечески — показываем тост с этим
      // текстом. Модалка со стеком нужна только тогда, когда объяснения нет:
      // менеджеру она всё равно ничего не даёт, а работу перекрывает.
      const humanText = humanErrorText(error?.response?.data);

      if (humanText) {
        alert.error(humanText);
      } else {
        showError({
          message,
          details,
          config: error.config,
        });
      }
    }

    return Promise.reject(error);
  }

  static async post(path, data, config = {}) {
    const headers = await defaultHeaders();
    return axios
      .post(`${path}`, data, { headers, ...config })
      .then((res) => {
        console.info('🪲 POST', path, data, res?.data);
        return res;
      })
      .catch(api.onError);
  }

  static async uploadFile(path, data, config = {}) {
    // const headers = await defaultHeaders();

    return axios
      .post(`${path}`, data, {
        // headers,
        ...config,
        'Content-Type': 'multipart/form-data',
      })
      .catch(api.onError);
  }

  static async put(path, data, config = {}) {
    const headers = await defaultHeaders();

    return axios.put(`${path}`, data, { headers, ...config }).catch(api.onError);
  }

  static async patch(path, data, config = {}) {
    const headers = await defaultHeaders();

    return axios.patch(`${path}`, data, { headers, ...config }).catch(api.onError);
  }

  static async delete(path, id) {
    const headers = await defaultHeaders();
    const url = [path, id].join('');

    return axios.delete(`${url}`, { headers }).catch(api.onError);
  }

  static async get(path, params = {}, config = {}) {
    const headers = await defaultHeaders();
    return axios
      .get(`${path}`, { headers, params, ...config })
      .then((res) => {
        console.info('🪲 GET', path, params, res?.data);
        return res;
      })
      .catch(api.onError);
  }
}
